import { useMemo } from 'react';
import { useMMGRSettings } from '../../../../utils/hoc/withMMGRSettings';
import { parseSiteMediaToken } from '../../../../utils/siteMediaToken';
import { wixOrEditorxDomain } from '../../../../utils/env/utils';

export const usePremium = () => {
  const {
    mmgrSettings: { siteMediaToken },
  } = useMMGRSettings();
  return useMemo(() => {
    const { metaSiteId } = parseSiteMediaToken(siteMediaToken);
    const upgradeUrl = `https://${wixOrEditorxDomain}/store/plans?siteGuid=${metaSiteId}`;
    return {
      upgradeUrl,
    };
  }, [siteMediaToken]);
};
